export enum UserRole {
  CLIENT = 'client'
}
